export const offersAR = {
  "shippingTitle": "الشحن مجانًا",
  "shippingText1": "للطلبات التي تزيد عن ",
  "shippingText2": "يورو الشحن مجانًا!",
  "cashTitle": "الدفع عند الاستلام",
  "cashText": "الدفع عند الاستلام مجاني!",
  "topSellers": "أفضل المبيعات"
}